import React from 'react';
import propTypes from 'prop-types';
import Layout, {
  LayoutHeader,
  LayoutBody,
  LayoutFooter
} from '../Layout';

import './Route.css';

import {connect} from 'react-redux';
import {
  PENDING,
  FAILURE
} from '../../../../../utils/status';
import * as routeHelper from '../../../../../helpers/route';
import * as navigator from '../../../../../native/navigator';
import isOnLine from '../../../../../native/isOnLine';
import { sendStatsEvent } from '../../../../../components/statistics/index';

Route.propTypes = {
  route: propTypes.object,
  status: propTypes.string.isRequired,
  day: propTypes.number.isRequired,
  trip: propTypes.object.isRequired
};

Route.defaultProps = {
  status: PENDING // 默认为pending
};

function Route(props) {
  let {status, route, trip, day} = props;
  let text = '';
  // 成功显示数据
  let success = false;

  if (status === PENDING) {
    text = '正在计算距离...';
  } else if (status === FAILURE) {
    text = isOnLine ? '网络连接出错，请稍后重新进入本行程' : '当前离线状态！';
  } else {
    // SUCCESS
    if (!route) {
      text = '添加下一站后，才可规划此段路线';
    } else {
      if (route.error) {
        // 计算直线
        let distance = routeHelper.getDistance(route.A_loc, route.B_loc);
        distance = routeHelper.formatDistance(distance);
        text = `暂不能规划线路（预计直线距离为${distance}公里）`;
      } else {
        success = true;
        let routeMap = {[route.key]: route};
        let distance = routeHelper.caculateDistance(routeMap);
        distance = routeHelper.formatDistance(distance);
        let duration = routeHelper.caculateDuration(routeMap);
        duration = routeHelper.formatDuration2(duration);
        text = `距离${distance}公里，驾车时间约${duration}`;
      }
    }
  }

  return (
    <Layout className='route' onClick={() => {
      if (!success) return;
      sendStatsEvent('trip_linedetails_click');
      navigator.push('/m/v2/?m=render2&page=route', {
        trip_id: trip.trip_id,
        day: day,
        poi_uids: `${route.A},${route.B}`
      });
    }}>
      <LayoutHeader className='header time-line'>
        <div className='circle'><span></span></div>
      </LayoutHeader>
      <LayoutBody className='body'>
        <div>{text}</div>
      </LayoutBody>
      {success ? (
        <LayoutFooter className='footer'>
          <i className='icon icon-arrow' />
        </LayoutFooter>
      ) : null}

    </Layout>
  );
}

export default connect(function (state, ownProps) {
  return {
    ...ownProps,
    status: state.route.route.status
  };
})(Route);



// WEBPACK FOOTER //
// ./src/pages/trip/Trip/DayTrip/PoiList/Route.js